import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, getToken, ServerErrorResponse } from './constants';
import { Permission } from 'types/permissions_response';

const url = `${baseApiUrl()}/lexid/admin-user-auth/v1/application`;

export const getApplicationPermissions = async (onError?: (errors: ServerErrorResponse) => void) => {
  const idToken = getToken();
  if (!idToken) {
    return [];
  }

  try {
    const respData = await fetcher({
      method: 'get',
      url: `${url}`,
    });
    const perms: Permission[] = respData?.authorizations ?? [];
    return perms;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function usePermissions(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  const idToken = getToken();
  return useQuery<Permission[], ServerErrorResponse>(
    ['permissions', idToken],
    async () => getApplicationPermissions(onError),
    {
      keepPreviousData: false,
      ...options,
      staleTime: Infinity, // Permissions are tied to token; refetch only when token (query key) changes
    }
  );
}
